import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import BarbaApp from './barba/BarbaApp';
import AutoplayVideos from './components/AutoplayVideos';
import VideoPlayer from './components/VideoPlayer';
import Header from './components/Header';

export class Pieters {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Pieters.domReady()]).then(() => this.init());
	}

	init() {
		new BarbaApp();
		new Header();
		new AutoplayVideos();
		new VideoPlayer();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Pieters();
